export default {"src":"https://images-cdn.curipod.com/d-680514d9/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};